import type { MiceProjectView } from '@voll-intelligence/domain';
import { t } from '@web/i18n';
import { IconButton } from '@web/ui/core';
import { Drawer } from '@web/ui/core/organisms';
import { PremisesPanel } from './premises_panel';
import { PremisesTimeline } from './premises_timeline';

interface PremisesDrawerProps {
  projectId: string;
  project: MiceProjectView;
  canManage: boolean;
  open: boolean;
  onClose: () => void;
}

/** O painel lateral de edição das premissas; abre pelo Resumo, pelo aviso e pelo checklist. */
export function PremisesDrawer(props: Readonly<PremisesDrawerProps>) {
  const { projectId, project, canManage, onClose } = props;
  return (
    <Drawer open={props.open} onClose={onClose} ariaLabel={t('mice.premises.title')}>
      <div className="flex flex-shrink-0 items-center justify-between border-b border-border-soft px-5 py-4">
        <span className="font-serif text-drawer-title text-foreground">
          {t('mice.premises.title')}
        </span>
        <IconButton
          icon="close"
          variant="outline"
          onClick={onClose}
          title={t('mice.drawer.close')}
          aria-label={t('mice.drawer.close')}
        />
      </div>
      <div className="flex flex-1 flex-col gap-4 overflow-y-auto px-5 py-5">
        {project.premises ? <PremisesTimeline premises={project.premises} /> : null}
        <PremisesPanel projectId={projectId} project={project} canManage={canManage} />
      </div>
    </Drawer>
  );
}
